import React from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import '../css/shopCategoryListStyle.css'
import '../css/admin.css'
import { HiOutlinePlus, HiOutlinePhotograph, HiOutlineSearch, HiOutlineEmojiSad, HiOutlineCollection, HiOutlineEye, HiOutlineEyeOff } from 'react-icons/hi';
import { MdNavigateBefore } from 'react-icons/md';
import ShopService from '../service/ShopService';
import { formatRupee } from '../components/Price';
import { ProductGridSkeleton } from '../components/Skeleton';
import EmptyState from '../components/EmptyState';
import Toast from '../components/Toast';
import ImageCropper from '../components/ImageCropper';
import { PRODUCT_PHOTO, checkPhotoFile } from '../util/imageFile';

const FILTERS = [
    { value: 'all', label: 'All' },
    { value: 'available', label: 'Available' },
    { value: 'hidden', label: 'Not available' }
]

class ShopCategoryList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryImage: "",
            selectedFile: null,
            category: "",
            createFile: null,
            itemImage: null,
            isAddOpen: false,
            createItemName: '',
            createDescription: null,
            categoryId: null,
            items: [],
            isLoading: true,
            loadError: false,
            isSaving: false,
            formError: '',
            search: '',
            filter: 'all',
            toast: '',
            cropSource: null
        };
    }

    // picking a photo opens the cropper; the cropped 3:4 JPEG is what gets uploaded
    onFileChange = event => {
        const picked = event.target.files[0]
        event.target.value = null
        if (!picked) return
        const problem = checkPhotoFile(picked)
        if (problem) {
            this.setState({ formError: problem })
        } else {
            this.setState({ formError: '', cropSource: picked })
        }
    };

    onCropped = (results) => {
        this.setState({
            cropSource: null,
            createFile: results.photo.file,
            selectedFile: results.photo.url,
            itemImage: results.photo.url
        })
    }

    onCropCancel = (message) => {
        this.setState({ cropSource: null, formError: message || this.state.formError })
    }

    onFileUpload = event => {
        event.preventDefault();
        const name = (this.state.createItemName || '').trim()
        if (name.length < 2) {
            this.setState({ formError: "Please enter a product name (at least 2 characters)." })
            return
        }
        if (this.state.createFile == null) {
            this.setState({ formError: "Please add a product image." })
            return
        }

        this.setState({ isSaving: true, formError: '' })
        const formData = new FormData();
        formData.append("file", this.state.createFile);
        formData.append("itemName", name);
        formData.append("description", this.state.createDescription);
        formData.append("categoryId", this.state.categoryId);

        ShopService.addNewShopItem(formData).then(res => {
            if (res.status === 200) {
                this.setState({
                    isSaving: false,
                    isAddOpen: false,
                    itemImage: null,
                    selectedFile: null,
                    toast: `${name} saved as hidden. Open it, add sizes, then switch it to On sale.`
                })
                this.updateShopItemsList();
            } else {
                this.setState({ isSaving: false })
            }
        }).catch(error => {
            this.setState({
                isSaving: false,
                formError: "Could not add the product. Please try again."
            })
        });
    };

    openView = param => e => {
        this.props.history.push({
            pathname: '/shop/inventory/item',
            state: { id: param }
        })
    };

    toggleAddForm = () => {
        this.setState({
            isAddOpen: !this.state.isAddOpen,
            formError: '',
            createItemName: '',
            createFile: null,
            itemImage: null,
            selectedFile: null
        })
    }

    onChangeCreateItemName = (event) => {
        this.setState({
            createItemName: event.target.value
        })
    }

    loadItems = (categoryId) => {
        return ShopService.getShopCategoryList(categoryId).then(response => {
            if (response.status) {
                const data = response.data.data
                this.setState({
                    category: data.categoryName,
                    categoryImage: data.image,
                    items: data.items || [],
                    isLoading: false,
                    loadError: false
                })
            }
        }).catch(error => {
            console.log(error)
            if (error?.response?.status === 401) {
                this.props.history.push('/login')
                return
            }
            this.setState({
                isLoading: false,
                loadError: true
            });
        });
    }

    updateShopItemsList() {
        this.loadItems(this.state.categoryId).then(() => {
            this.setState({
                createFile: null,
                createDescription: '55555555555555555',
                createItemName: ''
            })
        })
    }

    retry = () => {
        this.setState({ isLoading: true, loadError: false })
        this.loadItems(this.props.match.params.id)
    }

    componentDidMount() {
        const created = this.props.location && this.props.location.state && this.props.location.state.created
        this.setState({
            categoryId: this.props.match.params.id,
            toast: created ? `${created} saved as hidden. Open it, add sizes, then switch it to On sale.` : ''
        })
        this.loadItems(this.props.match.params.id)
    }

    renderAddForm() {
        const { itemImage, createItemName, isSaving, formError } = this.state
        return (
            <form className='mv-card mv-editor' onSubmit={this.onFileUpload} noValidate>
                <h2 className='mv-card-title'>New product</h2>
                <div className='mv-editor-body'>
                    <label className='mv-upload' htmlFor='product-image'>
                        {itemImage ? <img src={itemImage} alt='Product preview' /> :
                            <span className='mv-upload-empty'><HiOutlinePhotograph /> Add image</span>}
                        <input id='product-image' type='file' accept='image/jpeg,image/png,image/webp' onChange={this.onFileChange} />
                        {itemImage && <span className='mv-upload-change'>Change</span>}
                    </label>
                    <div className='mv-form'>
                        <div className='mv-field'>
                            <label className='mv-label' htmlFor='product-name'>Product name</label>
                            <input id='product-name' className='mv-input' placeholder='e.g. Baby Girl frock flower print'
                                value={createItemName} onChange={this.onChangeCreateItemName} autoFocus />
                            <span className='mv-field-hint'>The photo is cropped to 3:4 portrait. You can add sizes, prices and more photos after creating it.</span>
                        </div>
                    </div>
                </div>

                {formError && <div className='mv-alert mv-alert-error' role='alert'>{formError}</div>}

                <div className='mv-form-actions'>
                    <button type='submit' className='mv-btn mv-btn-primary' disabled={isSaving}>
                        {isSaving ? 'Adding…' : 'Add product'}
                    </button>
                    <button type='button' className='mv-btn mv-btn-secondary' onClick={this.toggleAddForm} disabled={isSaving}>Cancel</button>
                </div>
            </form>
        )
    }

    render() {
        const { category, isLoading, loadError, isAddOpen, items, search, filter, toast } = this.state
        const list = items || []
        const availableCount = list.filter(i => i.isAvailable).length
        const term = search.trim().toLowerCase()
        const visible = list.filter(item =>
            (filter === 'all' || (filter === 'available' ? item.isAvailable : !item.isAvailable)) &&
            (!term || String(item.name || '').toLowerCase().includes(term))
        )

        return (
            <main className='mv-page'>
                <Link to='/shop/inventory' className='mv-back-link'><MdNavigateBefore size={20} /> Inventory</Link>

                <div className='mv-page-head'>
                    <div>
                        <h1 className='mv-list-title'>{category || 'Products'}</h1>
                        {!isLoading && !loadError &&
                            <p className='mv-page-sub'>
                                {list.length} {list.length === 1 ? 'product' : 'products'} · {availableCount} available
                            </p>}
                    </div>
                    {!isAddOpen && !loadError &&
                        <button type='button' className='mv-btn mv-btn-primary mv-btn-sm' onClick={this.toggleAddForm}>
                            <HiOutlinePlus /> Add product
                        </button>}
                </div>

                {isAddOpen && <div className='mv-add-product'>{this.renderAddForm()}</div>}

                {loadError &&
                    <EmptyState icon={<HiOutlineEmojiSad />} title='We could not load these products'
                        text='Please check your connection and try again.' actionLabel='Try again' onAction={this.retry} />}

                {isLoading && <ProductGridSkeleton count={8} />}

                {!isLoading && !loadError && list.length === 0 && !isAddOpen &&
                    <EmptyState icon={<HiOutlineCollection />} title='No products yet'
                        text='Add the first product to this category.' actionLabel='Add product' onAction={this.toggleAddForm} />}

                {!isLoading && !loadError && list.length > 0 &&
                    <>
                        <div className='mv-list-tools'>
                            <label className='mv-search'>
                                <HiOutlineSearch aria-hidden='true' />
                                <span className='mv-visually-hidden'>Search products</span>
                                <input type='search' className='mv-input' placeholder='Search products'
                                    value={search} onChange={e => this.setState({ search: e.target.value })} />
                            </label>
                            <div className='mv-chip-row' role='tablist' aria-label='Filter by availability'>
                                {FILTERS.map(f =>
                                    <button type='button' key={f.value} role='tab' aria-selected={filter === f.value}
                                        className={filter === f.value ? 'mv-filter-chip active' : 'mv-filter-chip'}
                                        onClick={() => this.setState({ filter: f.value })}>
                                        {f.label}
                                    </button>
                                )}
                            </div>
                        </div>

                        {visible.length === 0 ?
                            <div className='mv-card mv-quiet'>No products match your search.</div> :
                            <div className='mv-product-grid'>
                                {visible.map(item =>
                                    <button type='button' key={item.itemId} className='mv-product-card' onClick={this.openView(item.itemId)}>
                                        <div className='mv-product-media'>
                                            <img className='mv-product-img' src={item.image} alt={item.name || 'Product'} loading='lazy' />
                                            <span className={item.isAvailable ? 'mv-chip mv-chip-discount mv-product-badge mv-avail' : 'mv-chip mv-chip-muted mv-product-badge mv-avail'}>
                                                {item.isAvailable ? <><HiOutlineEye /> Available</> : <><HiOutlineEyeOff /> Not available</>}
                                            </span>
                                        </div>
                                        <div className='mv-product-body'>
                                            <span className='mv-product-name'>{item.name}</span>
                                            {item.price != null && item.price !== '' && Number(item.price) > 0 ?
                                                <span className='mv-price'><span className='mv-price-final'>{formatRupee(item.price)}</span></span> :
                                                <span className='mv-product-meta'>Price not set</span>}
                                        </div>
                                    </button>
                                )}
                            </div>}
                    </>
                }

                <Toast message={toast} onDone={() => this.setState({ toast: '' })} />

                {this.state.cropSource &&
                    <ImageCropper file={this.state.cropSource} steps={[PRODUCT_PHOTO]} title='Crop product photo'
                        onDone={this.onCropped} onCancel={this.onCropCancel} />}
            </main>
        );
    }
}

export default withRouter(ShopCategoryList);
